import { observable, action } from 'mobx';
import { ITreeViewItem } from '../../interfaces/ITreeViewItem';

export class TreeViewStore {

  @observable public treeView: ITreeViewItem[];
  @observable public highlightColor: string;
  @observable public actionType?: "Checkbox" | "Radio";
  @observable public expanded: boolean;
  @observable public structureType?: "Folder" | "Arrow";

  @action public checkChildren(children: ITreeViewItem[], checked: boolean): void {
    children.forEach((item: ITreeViewItem) => {
      item.checked = checked;
      if (item.children) {
        this.checkChildren(item.children, checked);
      }
    });
  }

  @action public areSomeChildrenButNotAllChecked(item: ITreeViewItem): boolean {
    if (!item.children) {
      return false;
    }
    let childIsChecked = false;
    item.children.forEach((child: ITreeViewItem) => {
      if (child.checked) {
        childIsChecked = true;
      }
      if (child.children) {
        const grandchildChecked = this.areSomeChildrenButNotAllChecked(child);
        if (grandchildChecked) {
          childIsChecked = grandchildChecked;
        }
      }
    });
    return childIsChecked;
  }

  @action public uncheckAll(items?: ITreeViewItem[]): void {
    let itemsToUncheck: ITreeViewItem[] = items ? items : this.treeView;
    itemsToUncheck.forEach((item: ITreeViewItem) => {
      item.checked = false;
      if (item.children) {
        this.uncheckAll(item.children);
      }
    });
  }

}